import FeeTypeTagsSelect from './FeeTypeTagsSelect';

export default FeeTypeTagsSelect;
